(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivory-footer"] && !Shopify.designMode) return;
  try {
    

(function() {
  'use strict';

  /* ─── IntersectionObserver: fade-in on scroll ─── */
  var targets = document.querySelectorAll('.mc-fade-target');
  if (targets.length === 0) return;

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-mc-delay') || '0', 10);
          var stagger = parseInt(
            getComputedStyle(el).getPropertyValue('--mc-anim-stagger') || '120',
            10
          );
          setTimeout(function() {
            el.classList.add('mc-visible');
          }, delay * stagger);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function(t) { observer.observe(t); });
  } else {
    /* Fallback: show everything immediately */
    targets.forEach(function(t) { t.classList.add('mc-visible'); });
  }

  /* ─── Mobile: collapsible toggles ─── */
  var toggles = document.querySelectorAll('.mc-footer__col-toggle');
  toggles.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var AE_DESKTOP_QUERY = '(min-width: 990px)';
  function aeIsDesktop() {
    return !window.matchMedia || window.matchMedia(AE_DESKTOP_QUERY).matches;
  }

  function initMegaHeader(wrap) {
    if (!wrap) return;

    /* Mobile/tablet performance guard: do not initialize sticky, hover menu, product sliders, or hover panels. */
    if (!aeIsDesktop()) {
      wrap.dataset.aeMegaReady = 'mobile-skipped';
      wrap.style.display = 'none';
      wrap.style.minHeight = '';
      wrap.classList.remove('is-sticky');
      return;
    }

    if (wrap.dataset.aeMegaReady === 'true') return;
    wrap.dataset.aeMegaReady = 'true';
    wrap.style.display = '';

    var sid = wrap.id.replace('mega-header-', '');
    var header      = wrap.querySelector('#aeHeader-' + sid);
    var headerNav   = wrap.querySelector('#aeHeaderNav-' + sid);
    var megaWrapper = wrap.querySelector('#aeMegaPanelWrapper-' + sid);
    var megaPanel   = wrap.querySelector('#aeMegaPanel-' + sid);
    var blurOverlay = wrap.querySelector('#aeBlurOverlay-' + sid);
    var hoverBridge = wrap.querySelector('#aeHoverBridge-' + sid);

    if (!header || !headerNav || !megaWrapper || !megaPanel || !blurOverlay || !hoverBridge) return;

    function initSearchOverlay() {
      var overlay = wrap.querySelector('[data-ae-search-overlay]');
      if (!overlay || overlay.dataset.aeSearchReady === 'true') return;
      overlay.dataset.aeSearchReady = 'true';

      var openButtons = wrap.querySelectorAll('[data-ae-search-open]');
      var closeButtons = overlay.querySelectorAll('[data-ae-search-close]');
      var form = overlay.querySelector('[data-ae-search-form]');
      var input = overlay.querySelector('[data-ae-search-input]');
      var live = overlay.querySelector('[data-ae-search-live]');
      var resultsBox = overlay.querySelector('[data-ae-search-results]');
      var resultList = overlay.querySelector('[data-ae-search-result-list]');
      var debounceTimer = null;
      var lastQuery = '';
      var abortController = null;

      function escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function(ch) {
          return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#039;' })[ch];
        });
      }

      function getSearchSuggestUrl() {
        var action = (form && form.getAttribute('action')) || '/search';
        action = action.replace(/\/$/, '');
        return action + '/suggest.json';
      }

      function showResults(products) {
        if (!resultsBox || !resultList) return;

        if (!products || !products.length) {
          resultsBox.hidden = true;
          resultList.innerHTML = '';
          return;
        }

        resultList.innerHTML = products.slice(0, 4).map(function(product) {
          var title = escapeHtml(product.title);
          var url = product.url || '#';
          var price = product.price || product.compare_at_price || '';
          var image = product.image || product.featured_image || null;
          var imageHtml = image
            ? '<img src="' + escapeHtml(image) + '" alt="' + title + '" loading="lazy">'
            : '<svg viewBox="0 0 80 80" aria-hidden="true"><rect width="80" height="80" rx="14" fill="currentColor" opacity=".08"></rect><path d="M22 53l12-14 9 10 7-8 10 12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" opacity=".36"></path><circle cx="31" cy="29" r="5" fill="currentColor" opacity=".22"></circle></svg>';

          return '<a class="ae-search-result-item" href="' + escapeHtml(url) + '">' +
            '<span class="ae-search-result-img">' + imageHtml + '</span>' +
            '<span class="ae-search-result-info">' +
              '<span class="ae-search-result-title">' + title + '</span>' +
              (price ? '<span class="ae-search-result-price">' + escapeHtml(price) + '</span>' : '') +
            '</span>' +
          '</a>';
        }).join('');

        resultsBox.hidden = false;
      }

      function fetchSuggestions(query) {
        if (!window.fetch || !input) return;

        var q = query.trim();
        if (q.length < 2) {
          if (live) live.textContent = '';
          showResults([]);
          return;
        }

        lastQuery = q;
        if (abortController) abortController.abort();
        abortController = window.AbortController ? new AbortController() : null;

        if (live) live.textContent = 'Searching suggestions...';

        var url = getSearchSuggestUrl() +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product' +
          '&resources[limit]=4' +
          '&resources[options][unavailable_products]=last';

        fetch(url, { signal: abortController ? abortController.signal : undefined, headers: { 'Accept': 'application/json' } })
          .then(function(response) {
            if (!response.ok) throw new Error('Search suggestions unavailable');
            return response.json();
          })
          .then(function(data) {
            if (q !== lastQuery) return;
            var products = (((data || {}).resources || {}).results || {}).products || [];
            showResults(products);
            if (live) live.textContent = products.length ? '' : 'No quick suggestions found. Press Search to see full results.';
          })
          .catch(function(error) {
            if (error && error.name === 'AbortError') return;
            if (live) live.textContent = '';
            showResults([]);
          });
      }

      function openSearch(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        clearTimeout(openTimeout);
        clearTimeout(closeTimeout);
        closePanel();

        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('ae-search-open');

        window.setTimeout(function() {
          if (input) input.focus();
        }, 130);
      }

      function closeSearch() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('ae-search-open');
        if (live) live.textContent = '';
      }

      openButtons.forEach(function(btn) {
        btn.addEventListener('click', openSearch);
      });

      closeButtons.forEach(function(btn) {
        btn.addEventListener('click', closeSearch);
      });

      overlay.addEventListener('click', function(event) {
        if (event.target === overlay) closeSearch();
      });

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
          closeSearch();
        }
      });

      if (input) {
        input.addEventListener('input', function() {
          clearTimeout(debounceTimer);
          var value = input.value || '';
          debounceTimer = setTimeout(function() {
            fetchSuggestions(value);
          }, 220);
        });
      }

      if (form) {
        form.addEventListener('submit', function(event) {
          if (!input || input.value.trim().length) return;
          event.preventDefault();
          input.focus();
          if (live) live.textContent = 'Please type a product name or keyword first.';
        });
      }
    }

    function initAccountSheetBehavior() {
      wrap.querySelectorAll('shopify-account').forEach(function(account) {
        if (account.dataset.aeAccountReady === 'true') return;
        account.dataset.aeAccountReady = 'true';

        account.addEventListener('open', function() {
          clearTimeout(openTimeout);
          clearTimeout(closeTimeout);
          closePanel();
          document.documentElement.classList.add('ae-customer-account-open');
        });

        account.addEventListener('close', function() {
          document.documentElement.classList.remove('ae-customer-account-open');
        });
      });
    }

    var navItems   = headerNav.querySelectorAll('.ae-nav-item[data-panel]');
    var panelPages = megaPanel.querySelectorAll('.ae-panel-page[data-page]');

    var activePanel  = null;
    var openTimeout  = null;
    var closeTimeout = null;
    var OPEN_DELAY   = 120;
    var CLOSE_DELAY  = 240;

    function positionArrow(navItemEl) {
      if (!navItemEl) return;
      var navRect   = navItemEl.getBoundingClientRect();
      var navCenter = navRect.left + navRect.width / 2;

      if (megaPanel.classList.contains('is-mini-menu')) {
        var wrapperRect = megaWrapper.getBoundingClientRect();
        var miniWidth = 260;
        var minLeft = 12;
        var maxLeft = Math.max(minLeft, wrapperRect.width - miniWidth - 12);
        var miniLeft = Math.max(minLeft, Math.min(navCenter - wrapperRect.left - (miniWidth / 2), maxLeft));
        megaPanel.style.setProperty('--ae-mini-left', miniLeft + 'px');
        megaPanel.style.setProperty('--arrow-x', Math.max(18, Math.min(navCenter - wrapperRect.left - miniLeft, miniWidth - 18)) + 'px');
        return;
      }

      var panelRect = megaPanel.getBoundingClientRect();
      var offset    = Math.max(18, Math.min(navCenter - panelRect.left, panelRect.width - 18));
      megaPanel.style.setProperty('--arrow-x', offset + 'px');
      megaPanel.style.removeProperty('--ae-mini-left');
    }

    function showPanelPage(key) {
      panelPages.forEach(function(page) {
        var isCurrent = page.dataset.page === key;

        if (isCurrent) {
          var layout = page.dataset.panelLayout || 'hero';
          var isMiniMenu = layout === 'mini_dropdown';
          megaPanel.classList.toggle('is-mini-menu', isMiniMenu);
          megaWrapper.classList.toggle('is-mini-menu', isMiniMenu);
          blurOverlay.classList.toggle('is-mini-menu', isMiniMenu);
        }

        page.classList.toggle('is-visible', isCurrent);
      });
    }

    function openPanel(key, navItemEl) {
      clearTimeout(closeTimeout); closeTimeout = null;
      activePanel = key;
      navItems.forEach(function(ni) {
        ni.classList.toggle('is-active', ni.dataset.panel === key);
        ni.classList.remove('is-mini-open');
      });
      showPanelPage(key);
      var isMiniOpen = megaPanel.classList.contains('is-mini-menu');
      if (isMiniOpen && navItemEl) {
        navItemEl.classList.add('is-mini-open');
      }
      megaPanel.classList.add('is-open');
      if (isMiniOpen) {
        blurOverlay.classList.remove('is-active');
      } else {
        blurOverlay.classList.add('is-active');
      }
      hoverBridge.classList.add('is-active');
      header.classList.add('has-shadow');
      requestAnimationFrame(function() { positionArrow(navItemEl); });
    }

    function closePanel() {
      activePanel = null;
      navItems.forEach(function(ni) {
        ni.classList.remove('is-active');
        ni.classList.remove('is-mini-open');
      });
      panelPages.forEach(function(page) { page.classList.remove('is-visible'); });
      megaPanel.classList.remove('is-open');
      megaPanel.classList.remove('is-mini-menu');
      megaWrapper.classList.remove('is-mini-menu');
      blurOverlay.classList.remove('is-active');
      blurOverlay.classList.remove('is-mini-menu');
      hoverBridge.classList.remove('is-active');
      if (!wrap.classList.contains('is-sticky')) {
        header.classList.remove('has-shadow');
      }
    }

    function scheduleClose() {
      clearTimeout(openTimeout); openTimeout = null;
      closeTimeout = setTimeout(closePanel, CLOSE_DELAY);
    }

    function cancelClose() { clearTimeout(closeTimeout); closeTimeout = null; }

    navItems.forEach(function(item) {
      var key = item.dataset.panel;
      item.addEventListener('mouseenter', function() {
        cancelClose();
        clearTimeout(openTimeout);
        openTimeout = setTimeout(function() { openPanel(key, item); }, activePanel ? 0 : OPEN_DELAY);
      });
      item.addEventListener('mouseleave', function() {
        clearTimeout(openTimeout); openTimeout = null;
        scheduleClose();
      });
      item.addEventListener('focusin', function() {
        clearTimeout(openTimeout); cancelClose(); openPanel(key, item);
      });
    });

    megaWrapper.addEventListener('mouseenter', cancelClose);
    megaWrapper.addEventListener('mouseleave', scheduleClose);
    hoverBridge.addEventListener('mouseenter', cancelClose);
    hoverBridge.addEventListener('mouseleave', scheduleClose);

    blurOverlay.addEventListener('click', function() {
      clearTimeout(openTimeout); clearTimeout(closeTimeout); closePanel();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && activePanel) {
        clearTimeout(openTimeout); clearTimeout(closeTimeout); closePanel();
      }
    });

    var isSticky = false;
    var headerH = header.offsetHeight;
    var stickyThreshold = wrap.getBoundingClientRect().top + window.pageYOffset + headerH;

    function goSticky() {
      if (isSticky) return;
      isSticky = true;
      wrap.style.minHeight = headerH + 'px';
      wrap.classList.add('is-sticky');
      header.classList.add('has-shadow');
    }

    function goStatic() {
      if (!isSticky) return;
      isSticky = false;
      wrap.style.minHeight = '';
      wrap.classList.remove('is-sticky');
      if (!activePanel) header.classList.remove('has-shadow');
    }

    var scrollTicking = false;
    function updateStickyState() {
      if (window.pageYOffset >= stickyThreshold) {
        goSticky();
      } else {
        goStatic();
      }
      scrollTicking = false;
    }

    function onScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(updateStickyState);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function() {
      headerH = header.offsetHeight;
      stickyThreshold = wrap.getBoundingClientRect().top + window.pageYOffset + headerH;
      if (activePanel) {
        var activeNav = headerNav.querySelector('.ae-nav-item.is-active');
        positionArrow(activeNav);
      }
    });

    onScroll();

    function initProductMegaCategorySwitchers() {
      wrap.querySelectorAll('[data-ae-product-menu]').forEach(function(menu) {
        if (menu.dataset.aeCategoryReady === 'true') return;
        menu.dataset.aeCategoryReady = 'true';

        var tabs = menu.querySelectorAll('[data-ae-cat-tab]');
        var panels = menu.querySelectorAll('[data-ae-category-panel]');
        var promos = menu.querySelectorAll('[data-ae-promo-panel]');
        var globalViewAll = menu.querySelector('.ae-mm-global-view-all');

        function activate(key) {
          tabs.forEach(function(tab) {
            var active = tab.dataset.aeCatTab === key;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach(function(panel) {
            panel.classList.toggle('is-active', panel.dataset.aeCategoryPanel === key);
          });

          promos.forEach(function(promo) {
            promo.classList.toggle('is-active', promo.dataset.aePromoPanel === key);
          });

          var activePanel = menu.querySelector('[data-ae-category-panel="' + key + '"]');
          var activeView = activePanel ? activePanel.querySelector('.ae-concept-products__heading-link') : null;
          if (globalViewAll && activeView) {
            globalViewAll.href = activeView.href;
            globalViewAll.querySelector('span').textContent = activeView.textContent.trim();
          }
        }

        tabs.forEach(function(tab) {
          var key = tab.dataset.aeCatTab;
          tab.addEventListener('mouseenter', function() { activate(key); });
          tab.addEventListener('focus', function() { activate(key); });
          tab.addEventListener('click', function(e) { e.preventDefault(); activate(key); });
        });
      });
    }

    function initProductMegaImageSliders() {
      wrap.querySelectorAll('[data-ae-mm-slider]').forEach(function(slider) {
        if (slider.dataset.aeSliderReady === 'true') return;
        slider.dataset.aeSliderReady = 'true';

        var slides = slider.querySelectorAll('.ae-mm-slide');
        var dots = slider.querySelectorAll('.ae-mm-slide-dot');
        if (slides.length <= 1) return;

        var activeIndex = 0;
        var timer = null;
        var hoverTimer = null;
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function applyPositions(nextIndex, direction, oldIndex) {
          slides.forEach(function(slide, i) {
            slide.classList.remove('is-active', 'is-before', 'is-after');

            if (i === nextIndex) {
              slide.classList.add('is-active');
            } else if (i === oldIndex) {
              slide.classList.add(direction === 'backward' ? 'is-after' : 'is-before');
            } else {
              slide.classList.add(i < nextIndex ? 'is-before' : 'is-after');
            }
          });

          dots.forEach(function(dot, i) {
            dot.classList.toggle('is-active', i === nextIndex);
          });
        }

        function show(index, forcedDirection) {
          var next = Math.max(0, Math.min(slides.length - 1, index));
          if (next === activeIndex && slides[next].classList.contains('is-active')) return;

          var oldIndex = activeIndex;
          var direction = forcedDirection || (next > activeIndex || (activeIndex === slides.length - 1 && next === 0) ? 'forward' : 'backward');

          /*
            Prime the incoming slide before switching classes.
            This gives a true video-like horizontal slide instead of a fade.
          */
          slides[next].classList.remove('is-active', 'is-before', 'is-after');
          slides[next].classList.add(direction === 'backward' ? 'is-before' : 'is-after');
          void slides[next].offsetHeight;

          activeIndex = next;
          applyPositions(activeIndex, direction, oldIndex);
        }

        function start() {
          if (reduceMotion || timer) return;
          timer = setInterval(function() {
            show((activeIndex + 1) % slides.length, 'forward');
          }, 1450);
        }

        function stop() {
          if (!timer) return;
          clearInterval(timer);
          timer = null;
        }

        function resumeSoon() {
          if (hoverTimer) clearTimeout(hoverTimer);
          hoverTimer = setTimeout(start, 900);
        }

        /* Initial slide positions */
        applyPositions(activeIndex, 'forward', activeIndex);

        slider.addEventListener('mousemove', function(e) {
          var rect = slider.getBoundingClientRect();
          var percent = (e.clientX - rect.left) / rect.width;
          var mappedIndex = Math.floor(Math.max(0, Math.min(.999, percent)) * slides.length);
          var direction = mappedIndex >= activeIndex ? 'forward' : 'backward';
          stop();
          show(mappedIndex, direction);
          resumeSoon();
        });

        slider.addEventListener('mouseenter', start);
        slider.addEventListener('mouseleave', function() {
          if (hoverTimer) clearTimeout(hoverTimer);
          stop();
        });
        slider.addEventListener('focusin', stop);
        slider.addEventListener('focusout', stop);

        /* V17 performance: do not autoplay hidden mega-menu sliders on page load.
           A product card starts sliding only while the customer hovers that card. */
      });
    }

    initProductMegaCategorySwitchers();
    initProductMegaImageSliders();
    initSearchOverlay();
    initAccountSheetBehavior();


    headerNav.querySelectorAll('.ae-nav-link').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var item = link.closest('.ae-nav-item[data-panel]');
        if (!item) return;

        /*
          IMPORTANT:
          - Hover opens the mega menu.
          - If a real Nav URL is set, click should follow that URL.
          - Only prevent click when URL is empty / #, then use click as dropdown toggle.
        */
        var href = (link.getAttribute('href') || '').trim();
        var isEmptyHref = !href || href === '#' || href === window.location.href + '#';

        if (!isEmptyHref) {
          closePanel();
          return; // allow normal navigation to Nav URL
        }

        e.preventDefault();
        var key = item.dataset.panel;
        if (activePanel === key && megaPanel.classList.contains('is-open')) {
          closePanel();
        } else {
          clearTimeout(openTimeout); clearTimeout(closeTimeout); openPanel(key, item);
        }
      });
    });
  }

  function initAllMegaHeaders() {
    var wraps = document.querySelectorAll('.ae-mega-header-wrap[id^="mega-header-"]');

    if (!aeIsDesktop()) {
      wraps.forEach(function(wrap) {
        wrap.dataset.aeMegaReady = 'mobile-skipped';
        wrap.style.display = 'none';
        wrap.style.minHeight = '';
        wrap.classList.remove('is-sticky');
      });
      return;
    }

    wraps.forEach(function(wrap) {
      wrap.style.display = '';
      initMegaHeader(wrap);
    });
  }

  var aeResizeTimer = null;
  function scheduleMegaHeaderCheck() {
    clearTimeout(aeResizeTimer);
    aeResizeTimer = setTimeout(initAllMegaHeaders, 160);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllMegaHeaders);
  } else {
    initAllMegaHeaders();
  }

  window.addEventListener('resize', scheduleMegaHeaderCheck, { passive: true });
  window.addEventListener('orientationchange', scheduleMegaHeaderCheck, { passive: true });
  document.addEventListener('shopify:section:load', initAllMegaHeaders);
})();

  } catch(e) { console.error(e); }
})();
})();
